import { UPDATE_PROPERTY_NAVIGATION_TAB } from 'FormsUI/actions/PropertyNavigationTabs';
import * as PropertyNavigationTabs from 'FormsUI/constants/PropertyNavigationTabs';
const INITIAL_STATE = {
  active: PropertyNavigationTabs.EXISTING_PANEL
};
export function formPropertyNavigationTabs(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UPDATE_PROPERTY_NAVIGATION_TAB:
      return {
        active: action.tab
      };
    default:
      return state;
  }
}